<template>
    <comp-9-prep-adherence :section="9" :page="18" :next="nextScreen" :nextDisabled="nextDisabled">
        <p class="caption font-weight-bold mb-1 input-label">
            Are you prescribed:
        </p>
        <v-radio-group v-model="prepPrescriptionSelection" column>
            <v-radio v-for="prescription in prepPrescriptions" :key="prescription.id" :label="prescription.text" :value="prescription"></v-radio>
        </v-radio-group>
    </comp-9-prep-adherence>
</template>

<script>
import { sync } from 'vuex-pathify';
import { find, forEach } from 'lodash';

export default {
    data: function() {
        return {
            prepPrescriptionSelection: null
        };
    },
    computed: {
        prepPrescription() {
            let selectedPrepPrescription = find(this.prepPrescriptions, 'selected');

            if (selectedPrepPrescription) {
                return selectedPrepPrescription;
            } else return null;
        },
        prepPrescriptions: sync('section9/prepPrescription'),
        nextScreen() {
            if (this.prepPrescriptionSelection) {
                return `/page/9/${this.prepPrescriptionSelection.nextScreen}`;
            }

            return null;
        }
    },
    methods: {
        nextDisabled() {
            return !this.prepPrescriptionSelection;
        }
    },
    watch: {
        prepPrescriptionSelection(newPrepPrescriptionSelection) {
            forEach(this.prepPrescriptions, o => {
                if (o.id === newPrepPrescriptionSelection.id) {
                    o.selected = true;
                } else {
                    o.selected = false;
                }
            });
        }
    },
    mounted() {
        this.prepPrescriptionSelection = this.prepPrescription;
    }
};
</script>
